const namespaced = true

import api from '../../api/bank.js';
import _ from 'lodash';

const state = {
    banks: [],
    bankStore: {
        id: '',
        name: '',
        name_sap: '',
        ref: '',
        ref_sap: '',
        currency: '',
        cie_prefix: ''
    },
}
const mutations = {
    MUTATION_SET_BANKS(state, value) {
        state.banks = value;
    },
    MUTATION_SAVE_BANK(state, value) {
        state.banks.push(value);
    },
    MUTATION_UPDATE_BANK(state, value) {
        let banks = state.banks;
        state.banks = [];
        _.forEach(banks, (bank) => {
            state.banks.push(
                bank.id == value.id
                    ? value
                    : bank
            );
        });
    },
    MUTATION_DELETE_BANK(state, id) {
        let banks = state.banks;
        state.banks = [];
        _.forEach(banks, (bank) => {
            if (bank.id != id) {
                state.banks.push(bank);
            }
        });
    },

}
const actions = {
    getBanck(context) {
        return new Promise((resolve, reject) => {
            api.get().then(res => {
                context.commit('MUTATION_SET_BANKS', res.data);
                resolve(res.data);
            }).catch(function (error) {
                reject(error);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': 'Catálogo de bancos obtenidos correctamente' }, { root: true });
            })
        })
    },
    saveBank(context, data) {
        return new Promise((resolve, reject) => {
            api.store(data).then(res => {
                context.commit('MUTATION_SAVE_BANK', res.data);
                resolve(res.data);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Creado correctamente' }, { root: true });
            }).catch(error => {
                reject(error);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': error.messages }, { root: true });
            })
        })
    },
    updateBank(context, { id, data }) {
        return new Promise((resolve, reject) => {
            api.update(id, data).then(res => {
                context.commit('MUTATION_UPDATE_BANK', res.data);
                resolve(res.data);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Actualizado correctamente' }, { root: true });
            }).catch(error => {
                reject(error);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': error.messages }, { root: true });
            });
        });
    },
    deleteBank(context, id) {
        return new Promise((resolve, reject) => {
            api.deleted(id).then(res => {
                context.commit('MUTATION_DELETE_BANK', id);
                resolve(res.data);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Eliminado correctamente' }, { root: true });
            }).catch(error => {
                reject(error);
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': error.messages }, { root: true });
            });
        });
    },
}

const getters = {

}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}
